import { render, staticRenderFns } from "./CollectionFinished.vue?vue&type=template&id=08bb7c76&scoped=true&"
import script from "./CollectionFinished.vue?vue&type=script&lang=js&"
export * from "./CollectionFinished.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFinished.vue?vue&type=style&index=0&id=08bb7c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb7c76",
  null
  
)

export default component.exports